import { BulkUpdateProgressBanner } from "#src/batteries-included-components/Banners/BulkUpdateProgressBanner/BulkUpdateProgressBanner";
import { ESTIMATION_METHODS_QUERY_KEY } from "#src/components/hooks/adapters/useEstimationMethods";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useQueryClient } from "@tanstack/react-query";
import { AssetStatus } from "@validereinc/domain";
import React from "react";
import { useParams } from "react-router";

export const EquipmentUpdateStatusBanner = () => {
  const { equipmentId } = useParams<{ equipmentId: string }>();
  const queryClient = useQueryClient();
  const [updateEquipmentStatusJobStorageKey] = useStorageKey(
    ["async-job"],
    `update-equipment-status-${equipmentId}`
  );
  return (
    <BulkUpdateProgressBanner
      jobStorageKey={updateEquipmentStatusJobStorageKey}
      invalidate={() => {
        queryClient.refetchQueries({
          predicate: (query) =>
            ["flows", "equipment", ESTIMATION_METHODS_QUERY_KEY].some((key) =>
              query.queryKey.includes(key)
            ),
          type: "all",
        });
      }}
      subject={{
        singular: "asset",
        plural: "assets",
      }}
      action={(job) =>
        job?.input.status === AssetStatus.INACTIVE ? "inactivate" : "activate"
      }
    />
  );
};
